module.exports = __webpack_public_path__ + "img/devpost.4e269012.svg";